/* eslint-disable indent */

<template>
  <sui-form v-if="test">
    <sui-form-field v-bind:class="fieldClass('valid-for-hours')">
      <label>Students can access the nominations page for</label>
      <sui-dropdown
        placeholder="Students can access the nominations page for"
        selection
        v-validate="'required'"
        name="valid-for-hours"
        :options="durations"
        v-model="test.ValidForHours"
      />
      <span>{{ errors.first('valid-for-hours') }}</span>
    </sui-form-field>
    <sui-form-field
      v-if="languages.length > 1 && !extend"
      class="required"
      v-bind:class="fieldClass('defaultLanguage')"
    >
      <label>Default language</label>
      <sui-dropdown
        placeholder="Default language"
        selection
        v-validate="'required'"
        name="defaultLanguage"
        :options="languages"
        v-model="test.DefaultLanguage"
      />
    </sui-form-field>
    <sui-form-field
      v-if="languages.length <= 0 && !extend"
      class="required"
      v-bind:class="fieldClass('defaultLanguage')"
    >
      <input
        type="hidden"
        v-validate="'required'"
        name="defaultLanguage"
        v-model="test.DefaultLanguage"
      />
    </sui-form-field>
    <div v-if="error" class="ui negative message">
      <p>{{ error }}</p>
    </div>
    <div>
      <p>
        <!-- eslint-disable-next-line max-len -->
        Once you click the below 'Start' button a unique URL/Link will be
        generated for you to give to your students.
        <!-- eslint-disable-next-line max-len -->
        If an absent student has not made their Nominations within the selected
        time period more time can be allocated by visiting the Reports page and
        selecting Extend.
      </p>
    </div>
    <br />
    <sui-button type="button" positive icon="thumbs up" v-on:click="submit">
      {{ submitButtonText }}
    </sui-button>
  </sui-form>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'StartTestForm',
  computed: {
    ...mapGetters({
      school: 'usersSchool',
    }),
    submitButtonText() {
      return this.submitButtonLabel || 'Start';
    },
    languages() {
      if (!this.school) {
        return [
          { text: 'English', value: 'en' },
          { text: 'Irish', value: 'ga' },
        ];
      }
      if (this.school.length === 0) {
        return [
          { text: 'English', value: 'en' },
          { text: 'Irish', value: 'ga' },
        ];
      }
      return (
        this.school.availableLanguages
          // eslint-disable-next-line arrow-parens
          .map((l) => ({
            text: this.mapLanguageCode(l),
            value: l,
          }))
          .sort((a, b) => a.text.localeCompare(b.text))
      );
    },
  },
  props: ['test', 'error', 'submitButtonLabel', 'extend'],
  methods: {
    mapLanguageCode(languageCode) {
      switch (languageCode) {
        case 'en':
          return 'English';
        case 'ga':
          return 'Irish';
        default:
          return languageCode;
      }
    },
    reset() {
      this.$validator.reset();
    },
    fieldClass(name) {
      const result = [];
      if (this.errors.first(name)) {
        result.push('error');
      }
      return result;
    },
    submit() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.$emit('saved');
        }
      });
    },
  },
  created() {
    this.$store.dispatch('getSchoolForUser');
  },
  data() {
    return {
      durations: [
        { text: '1 hour', value: 1 },
        { text: '2 hours', value: 2 },
        { text: '3 hours', value: 3 },
        { text: '4 hours', value: 4 },
        { text: '5 hours', value: 5 },
        { text: '6 hours', value: 6 },
        { text: '7 hours', value: 7 },
        { text: '8 hours', value: 8 },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tests/StartTestForm.vue